import styled, { keyframes } from 'styled-components'
import variables from '../../styles/variables'

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`

export const Container = styled.div`
  width: 100%;
  background: ${variables.colors.white};
  padding: 40px 0;
  overflow: hidden;
  
  @media ${variables.media.sm} {
    padding: 60px 0;
  }
`

export const Content = styled.div`
  max-width: ${variables.maxContentWidth}px;
  margin: 0 auto;
  padding: 0 20px;
`

export const Title = styled.h3`
  text-align: center;
  color: ${variables.colors.charcoal};
  margin-bottom: 30px;
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: 0.7;
`

export const LogoWrapper = styled.div`
  position: relative;
  overflow: hidden;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100px;
    z-index: 2;
    pointer-events: none;
  }
  
  &::before {
    left: 0;
    background: linear-gradient(to right, ${variables.colors.white} 0%, transparent 100%);
  }
  
  &::after {
    right: 0;
    background: linear-gradient(to left, ${variables.colors.white} 0%, transparent 100%);
  }
`

export const LogoTrack = styled.div`
  display: flex;
  align-items: center;
  gap: 60px;
  
  @media ${variables.media.sm} {
    gap: 80px;
  }
  
  @media (max-width: 768px) {
    animation: ${scroll} 30s linear infinite;
  }
`

export const LogoItem = styled.div`
  flex-shrink: 0;
`

export const LogoLink = styled.a`
  display: block;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.7;
  }
`

export const Logo = styled.img`
  height: 40px;
  width: auto;
  filter: grayscale(100%) opacity(0.8);
  transition: filter 0.2s ease;
  
  @media ${variables.media.sm} {
    height: 50px;
  }
  
  ${LogoLink}:hover & {
    filter: grayscale(0%) opacity(1);
  }
`